import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Layout } from "@/components/Layout";
import { ProductCard } from "@/components/ProductCard";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const CATS = ["All", "Gifts", "Toys", "Decor", "Stationery", "New / Other"];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "All";
  const bestseller = params.get("bestseller") === "true";
  const [sort, setSort] = useState("newest");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const p = { sort };
    if (category !== "All") p.category = category;
    if (bestseller) p.bestseller = true;
    api.get("/products", { params: p }).then(({ data }) => {
      setProducts(data);
      setLoading(false);
    });
  }, [category, sort, bestseller]);

  const setCategory = (c) => {
    const next = new URLSearchParams(params);
    if (c === "All") next.delete("category");
    else next.set("category", c);
    next.delete("bestseller");
    setParams(next);
  };

  return (
    <Layout>
      <div className="bg-blush py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 text-center">
          <p className="eyebrow">The boutique</p>
          <h1 className="mt-3 font-serif text-4xl lg:text-5xl text-charcoal">
            {bestseller ? "Best Sellers" : category === "All" ? "Shop All" : category}
          </h1>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-10">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-10">
          <div className="flex flex-wrap gap-2">
            {CATS.map((c) => (
              <button
                key={c}
                data-testid={`filter-${c.toLowerCase().replace(/[^a-z]/g, "")}`}
                onClick={() => setCategory(c)}
                className={`px-4 py-2 text-xs font-display uppercase tracking-[0.12em] rounded-full border transition-colors ${
                  category === c && !bestseller
                    ? "bg-charcoal text-white border-charcoal"
                    : "border-soft-border text-charcoal/70 hover:border-gold"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <Select value={sort} onValueChange={setSort}>
            <SelectTrigger data-testid="sort-select" className="w-48 rounded-none border-charcoal/20 bg-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-white">
              <SelectItem value="newest">Newest</SelectItem>
              <SelectItem value="price_asc">Price: Low to High</SelectItem>
              <SelectItem value="price_desc">Price: High to Low</SelectItem>
            </SelectContent>
          </Select>
        </div>

        {loading ? (
          <p className="text-center text-charcoal/50 py-20">Loading…</p>
        ) : products.length === 0 ? (
          <p className="text-center text-charcoal/50 py-20" data-testid="no-products">
            No products found in this collection.
          </p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8" data-testid="product-grid">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
